import {Breadcrumb} from './types';

const createBreadcrumb = (label: string, to?: string): Breadcrumb => ({label, to});

export default createBreadcrumb;